import APIClient from '@/shared/http/clients/api'

const resourceName = 'apr'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetByIds = (data = {}, config = {}) => APIClient.post(`${APIBusinessCommon}/${resourceName}/aprvistoria`, data, config)

const aprsurveyRepository = {
  GetByIds
}
export default aprsurveyRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/aprsurvey.js